// import './style.scss';
// import { createRoot } from 'react-dom/client';

// const ProductDetail = (props) => {
//   const {
//     productDetail = '',
//     selectedAttributes = [],
//     htmlTag = 'div',
//     className,
//     postId = 0,
//   } = props;

//   const TagName = htmlTag || 'div';

//   // Fetch the product data from RTSWooProductDetail
//   const products = window.RTSWooProductDetail
//     ? window.RTSWooProductDetail.product
//     : [];

//   // Find the product with matching postId
//   const product = products.find((p) => p.id == postId);

//   if (!product) {
//     return (
//       <TagName className={className}>
//         {'No product data available'}
//       </TagName>
//     );
//   }

//   // Prepare content based on productDetail
//   let content = '';

//   if (productDetail === 'attributes') {
//     // Handle custom attributes
//     const items = selectedAttributes.map((attr) => {
//       const value = product.product_taxonomies[attr] || '';
//       return { attr, value };
//     });

//     content = (
//       <div className="attributes-container">
//         {items.map((item, index) => {
//           const { attr, value } = item;
//           return (
//             value && (
//               <div className="attributes-item" key={index}>
//                 <p className="label">{attr}</p>
//                 <p className="value">{value}</p>
//               </div>
//             )
//           );
//         })}
//       </div>
//     );
//   } else if (productDetail) {
//     // Handle other product details
//     const value = product[productDetail];

//     if (value !== undefined) {
//       if (productDetail === 'price') {
//         content = new Intl.NumberFormat('en-US', {
//           style: 'currency',
//           currency: 'USD',
//         }).format(value);
//       } else if (productDetail === 'mileage') {
//         content = `${value} Miles`;
//       } else {
//         content = value;
//       }
//     } else {
//       content = 'No details available';
//     }
//   } else {
//     content = 'No details available';
//   }

//   return (
//     <TagName className={className}>
//       {content}
//     </TagName>
//   );
// };

// document.addEventListener('DOMContentLoaded', () => {
//   const elements = document.querySelectorAll(
//     '.wp-block-rts-woo-blocks-product-individual-details'
//   );

//   elements.forEach((el) => {
//     if (!el.hasAttribute('data-rendered')) {
//       el.setAttribute('data-rendered', 'true');
//       try {
//         // Parse block attributes from the comment delimiters
//         const blockData = JSON.parse(el.dataset.blockAttributes || '{}');

//         const {
//           productDetail = '',
//           selectedAttributes = [],
//           htmlTag = 'div',
//           postId = 150997,
//         } = blockData;

//         const componentProps = {
//           productDetail,
//           selectedAttributes,
//           htmlTag,
//           className: el.className,
//           postId,
//         };

//         const root = createRoot(el);
//         root.render(<ProductDetail {...componentProps} />);
//       } catch (e) {
//         console.error('Error parsing block data:', e);
//       }
//     }
//   });
// });

import './style.scss';

// Since the content is now rendered server-side, we no longer need to fetch product data or render components on the client-side.

// If you have any client-side interactions or need to enhance the block with JavaScript, you can add your code here.

// For example, if you need to handle click events or manipulate the DOM after the content is loaded:

document.addEventListener('DOMContentLoaded', () => {
  // Example: Add event listeners or manipulate the block's content
  const elements = document.querySelectorAll('.wp-block-rts-woo-blocks-product-individual-details');
  
  const comment = document.querySelector('.comments');
  const commentsLabel = document.querySelector('.comments-label');

  if (!comment && commentsLabel) {
    commentsLabel.style.display = 'none';
  }
  elements.forEach((el) => {
    // Add your client-side logic here if needed
  });
});